import Donation from "./Donation";
import Ticket from "./Ticket";

const TicketDisplay = ({
  ticket,
  tickets,
  updateDonationAmount,
  addQuantity,
  addPrice,
  ticketsRemainingDisplay,
  eventSoldOut,
  showCustomDonationField,
  donationOtherOption,
  ticketGroupIndex
}) => {
  if (ticket.isDonation) {
    return (
      <Donation
        ticket={ticket}
        updateDonationAmount={updateDonationAmount}
        showCustomDonationField={showCustomDonationField}
        donationOtherOption={donationOtherOption}
      />
    );
  } else {
    return (
      <Ticket
        ticket={ticket}
        addQuantity={addQuantity}
        addPrice={addPrice}
        eventSoldOut={eventSoldOut}
        ticketsRemainingDisplay={ticketsRemainingDisplay}
        ticketGroupIndex={ticketGroupIndex}
      />
    );
  }
};

export default TicketDisplay;



// WEBPACK FOOTER //
// ./routes/tickets/components/TicketDisplay.js